import { createRoutineCreator } from 'redux-saga-routines';

const createAlertRoutine = createRoutineCreator(['SHOW', 'HIDE', 'ACCEPT', 'REJECT', 'REJECT_ALL']);
export const alertRoutine = createAlertRoutine('ALERT')